import { defineStore } from "pinia";
import http from "@/http";
import { LIST_CLIENTE, ADD_CLIENTE, UPDATE_CLIENTE, DEL_CLIENTE } from "@/http/url";

export const useClienteStore = defineStore("ClienteStore", {
  state: () => {
    return {
      clientes: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_CLIENTES() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_CLIENTE)
          .then((response) => {
            this.clientes = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_CLIENTE(cliente) {
      return http
        .post(ADD_CLIENTE, cliente)
        .then((response) => this.clientes.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_CLIENTE(cliente) {
      return http.put(`${UPDATE_CLIENTE + cliente.id}`, cliente);
    },

    REMOVER_CLIENTE(id) {
      return http
        .delete(`${DEL_CLIENTE + id}`)
        .then(() => (this.clientes = this.clientes.filter((cli) => cli.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getClientes() {      
      return this.clientes;
    },

    getClienteLoad(state) {
      return state.loaded;
    },

    getFilterClientes: (state) => {
      return (filtro) => state.clientes.filter((c) => !filtro || c.nome.includes(filtro));
    },
  },
});
